/* Width is the consumer's business (tile banner, dialog header, editor preview). */
.cover {
  display: block;
  height: var(--cover-height, 7rem);
  object-fit: cover;
  user-select: none;
}
